export default __webpack_public_path__ + "static/media/pdf.49d3d0c8.svg";